/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SearchHandlerInfo = {
    IDX: SearchHandlerInfo.IDX;
    SRLIST: Record<string, any>;
};

export namespace SearchHandlerInfo {

    export enum IDX {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        MODULE = 'MODULE',
    }


}

